import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Global connectivity banner. This is the shared "interrupting action" surface
// (ADR-0002: network drop) — the E2E harness toggles `context.setOffline(true)`
// and asserts this banner, so every later feature inherits an offline signal.
// The banner is an aria-live region so assistive tech announces the change.
export function ConnectionStatus() {
  const { t } = useTranslation();
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="connection-status"
      data-online={online}
      className={online ? "connection-status connection-status--online" : "connection-status connection-status--offline"}
      hidden={online}
    >
      {online ? t("states.online") : t("states.offline")}
    </div>
  );
}
